import SecuredCardForgotPage from "./SecuredCardForgotPage";
export default SecuredCardForgotPage;
